import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_ACTIVITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/activities/new")({
  component: () => <DeptContentForm cfg={CFRD_ACTIVITIES} />,
});
